import productFeedApi from 'common/src/modules/productFeed/productFeed.api';
import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {z} from 'zod';
import {CampaignSetupAgentToolName} from '../../campaignSetupAgent.enums';

const MAX_PRODUCT_FEEDS_COUNT = 10;

const getProductFeedToolSchema = z.object({
  prompt: z
    .string()
    .describe('Detailed description of the product feed to search for following the user prompt.'),
  maxCount: z.number().describe('The maximum number of product feeds to return'),
});

export default function getLocationFeedTool() {
  async function execute({
    input: {prompt},
  }: ToolExecuteParams<typeof getProductFeedToolSchema>): Promise<ToolResult> {
    try {
      // Get all feeds
      const searchResponse = await productFeedApi.searchFeeds(prompt);

      if (!searchResponse.productFeeds.length) {
        return toolResult(`No product feeds found. Reason: ${searchResponse.filtersExplanation}`);
      }

      const productFeeds = searchResponse.productFeeds.slice(0, MAX_PRODUCT_FEEDS_COUNT);

      return toolResult(
        JSON.stringify({
          productFeeds: productFeeds.map((feed) => ({
            id: feed.id,
            name: feed.name,
            productType: feed.productType,
            instructions:
              productFeeds.length > 1
                ? `More than one product feed found, use the first product feed and ask the user for clarification.`
                : '',
          })),
        }),
      );
    } catch (error) {
      return toolResult(
        `Error retrieving product feeds: ${
          error instanceof Error ? error.message : 'Unknown error'
        }`,
      );
    }
  }

  return tool({
    name: CampaignSetupAgentToolName.GetProductFeeds,
    displayName: 'Searching product feeds',
    description: "Search for feeds from account's product feeds library based on a prompt.",
    execute,
    inputSchema: getProductFeedToolSchema,
  });
}
